
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "coreforms",
	init: init,
	listeners: listeners,
	triggers: triggers,
	refresh: refresh,
	_loaded: false,
});

function init() {
	this.push({});
}

function listeners() {
	return {
		"connectivity:online": refresh
	};
}

function triggers() {
	return {
		load: load_forms,
	};
}

function load_forms() {
	if(this._loaded) return;
	this._loaded = true;
	this.refresh();
}

function refresh() {
	if(!this._loaded) return;
	this.api.forms.list.core().then(handle_forms.bind(this));
}

function handle_forms(forms) {
	this.push(forms.reduce(function (result, form) {
		var update = {};
		update[form.name] = form;
		return xtend(result, update);
	}, {}));
}
